export const dreLineRoutes = {
  list: '/panel/financial/dre-line',
} as const;
